export default {
  english: 'الأنجليزية',
  arabic: 'العربية',
  login: 'تسجيل الدخول',
  cart: 'سلة المشتريات',
  sidebar: {
    dashboard: 'لوحة التحكم',
    insurance_policy: 'بوليصة التامين',
    settings: 'الاعدادات',
    products: 'المنتجات',
    orders: 'طلبات',
    offers: 'العروض',
    withdraw: 'سحب',
    reviews: 'التعليقات',
    categories: 'الأقسام',
    collection: 'المجموعات',
    processing: 'فى الإنتظار',
    collections: 'مجموعات'
  }
}
